<template>
  <div class="d-flex justify-content-center">
    <half-circle-spinner class="spinner" :animation-duration="1000" :size="30" color="#ed4040" />
  </div>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";

export default {
  components: { HalfCircleSpinner }
};
</script>

<style>
.d-flex {
  z-index: 100000;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.3;
  flex-direction: column;
}
.spinner {
  align-self: center;
}
</style>
